<button
    [ngClass]="{
        'disabled': disabled,
        'drop-shadow': themeService.buttonConfig().primary.shadow && type === 'primary' && !backgroundColor,
        'hug': layout === 'hug',
        'fill': layout === 'fill',
        'gradient': type === 'primary' && themeService.buttonConfig().primary.gradient && !backgroundColor,
        'outline': type === 'primary' && themeService.buttonConfig().primary.outline && !backgroundColor,
        'primary': type === 'primary',
        'secondary': type === 'secondary',
        'icon-only': !label,
    }"
    [ngStyle]="backgroundStyle"
    [disabled]="disabled"
    (click)="onClick()"
>
    <!-- Icon on left or as icon-only -->
    <ng-container *ngIf="icon && (!label || iconPos === 'left') && !loading">
        <span class="icon">
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </span>
    </ng-container>

    <!-- Label -->
    <span 
        *ngIf="label && !loading" 
        class="typography--text typography--text--size--medium typography--weight--semi-bold"
        [style.text-transform]="themeService.buttonConfig().textTransform">
        {{ label }}
    </span>

    <!-- Icon on right -->
    <ng-container *ngIf="icon && iconPos === 'right' && label">
        <span class="icon && !loading">
            <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        </span>
    </ng-container>

    <ng-template #iconTemplate>
        <app-icon
            *ngIf="icon && !loading"
            [icon]="icon"
            [colorCss]="type === 'primary' ? '--button-primary-label' : '--button-secondary-icon-color'" 
            sizeCss="--icon-medium">
        </app-icon>
    </ng-template>

    <ion-spinner 
        *ngIf="loading" 
        name="crescent" 
        [ngClass]="{
            'primary': type === 'primary',
            'secondary': type === 'secondary',    
        }"
        class="spinner"/>
</button>
